import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useResetPassword = (): IGlobalStore['reset_password'] => {
  return useSelector((store: IReducerStore) => store.global.reset_password);
};
